import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

export const SharedModule = {
  state,
  actions,
  mutations,
  getters
};

export default {};
